import { addHours } from 'date-fns';

import { localDate } from '@iconik-io/core/src/date/format';

export const getCookie = (cname: string): string => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

type SetCookieParams = {
  key: string;
  value: string;
  expirationValue?: number;
  expirationDate?: string;
  path?: string;
};

export const setCookie = ({
  key,
  value = 'true',
  expirationValue = 1,
  expirationDate,
  path,
}: SetCookieParams): string | boolean => {
  if (!key) {
    return false;
  }

  let cookie = '';
  if (key && value) {
    cookie = `${key}=${value};`;
  }

  let expiration = '';
  if (expirationValue) {
    const date = addHours(localDate(), expirationValue);
    expiration = `expires=${date}`;
  }

  if (expirationDate) {
    expiration = `expires=${expirationDate}`;
  }

  let cookiePath = '';
  if (path) {
    cookiePath = `path=${path}`;
  }

  const cookieStr = `${cookie} ${expiration}${
    cookiePath ? ';' : ''
  } ${cookiePath}`;
  // biome-ignore lint/suspicious/noDocumentCookie: cookie util
  document.cookie = cookieStr;
  return cookieStr;
};
